import React, { Suspense } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AppContextProvider } from "./components/AppContext";
import { ErrorZone } from "./components/ErrorZone";
import { LoadingSpinner } from "./components/LoadingSpinner";
import { PageRoutes } from "./PageRoutes";
import { ScrollToTop } from "./components/ScrollToTop";
import { darkTheme, lightTheme } from "./scottdbTheme";
import { ThemeModeProvider, useThemeMode } from "./ThemeModeContext";
import { AuthProvider } from "./auth/AuthContext";
import { UserActivityTracker } from "./auth/UserActivityTracker";

function ThemedApp() {
  const { mode } = useThemeMode();
  const theme = mode === "dark" ? darkTheme : lightTheme;

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <UserActivityTracker />
          <Suspense fallback={<LoadingSpinner message="Loading..." />}>
            <PageRoutes />
          </Suspense>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export function App() {
  return (
    <ErrorZone>
      <HelmetProvider>
        <AppContextProvider>
          <ThemeModeProvider>
            <ThemedApp />
          </ThemeModeProvider>
        </AppContextProvider>
      </HelmetProvider>
    </ErrorZone>
  );
}
